export const setArtBoardShapePath = (self, { path_data }) => {
  const art_board_shape_path_el = self._getArtBoardShapePathElThrowable();
  art_board_shape_path_el.setAttributeNS(null, "d", path_data);
};
